import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Course List")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-2 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, null, -1)
const _hoisted_19 = { class: "card mb-5 mb-xl-10" }
const _hoisted_20 = {
  id: "entity_target_list",
  class: "collapse show"
}
const _hoisted_21 = { class: "collapse show" }
const _hoisted_22 = { class: "card-body border-top p-0" }
const _hoisted_23 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = { class: "card-body border-top p-6" }
const _hoisted_27 = {
  class: "col-md-12 text-end mb-3 p-0",
  "data-v-54b12dc8": ""
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_35 = { class: "pt-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-copy" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_templete = _resolveComponent("templete")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_CourseInfoDrawer = _resolveComponent("CourseInfoDrawer")!
  const _component_CourseCopyDrawer = _resolveComponent("CourseCopyDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.batch.tranche_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                        options: _ctx.optionsTranche,
                        mode: "tags",
                        "clear-on-select": false,
                        placeholder: "Select Tranche",
                        "close-on-select": false,
                        searchable: true,
                        "create-option": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        options: _ctx.optionsTPartner,
                        mode: "tags",
                        "clear-on-select": false,
                        placeholder: "Select Training Partner",
                        "close-on-select": false,
                        searchable: true,
                        "create-option": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Training Institute",
                        modelValue: _ctx.batch.institute_info_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_info_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (inst) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: inst.id,
                              label: inst.institute_name,
                              value: inst.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(inst.institute_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "institute_info_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.courseInfoList())),
                        type: "button",
                        class: "btn btn-success mt-6 p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_17
                      ])
                    ])
                  ]),
                  (_ctx.courseInfoData == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: _ctx.componentKey,
                        class: "mt-3"
                      }, [
                        _hoisted_18,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", null, [
                                      _hoisted_24,
                                      (_openBlock(), _createElementBlock("div", {
                                        id: "trainee_data",
                                        class: "collapse show",
                                        key: _ctx.componentKey
                                      }, [
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                                title: "Download Xlse",
                                                "data-v-54b12dc8": "",
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                                              }, _hoisted_29),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                                title: "Download PDF",
                                                "data-v-54b12dc8": "",
                                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                                              }, _hoisted_31),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                                title: "Print",
                                                "data-v-54b12dc8": "",
                                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                                              }, _hoisted_33)
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                              _createVNode(_component_Datatable, {
                                                "table-data": _ctx.courseList,
                                                "table-header": _ctx.courseHeader,
                                                "enable-items-per-page-dropdown": true
                                              }, {
                                                "cell-code": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row.code), 1)
                                                ]),
                                                "cell-course_name": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.course_name), 1)
                                                ]),
                                                "cell-term": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row.term), 1)
                                                ]),
                                                "cell-session": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row.session), 1)
                                                ]),
                                                "cell-course_type": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.course_type_info?.type_name), 1)
                                                ]),
                                                "cell-contract_name": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.contract_info?.contract_name), 1)
                                                ]),
                                                "cell-skill_level_id": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.course_skill_level?.name), 1)
                                                ]),
                                                "cell-isManagementCourse": _withCtx(({
                                            row,
                                          }) => [
                                                  _createTextVNode(_toDisplayString(row.isManagementCourse == 1
                                              ? 'Yes'
                                              : 'No'), 1)
                                                ]),
                                                "cell-isStipendCourse": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row.isStipendCourse == 1
                                              ? 'Yes'
                                              : 'No'), 1)
                                                ]),
                                                "cell-isTotCourse": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row.isTotCourse == 1 ? 'Yes' : 'No'), 1)
                                                ]),
                                                "cell-isEmploymentEligible": _withCtx(({
                                            row,
                                          }) => [
                                                  _createTextVNode(_toDisplayString(row.isEmploymentEligible == 1
                                              ? 'Yes'
                                              : 'No'), 1)
                                                ]),
                                                "cell-month": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.month), 1)
                                                ]),
                                                "cell-hour": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.hour), 1)
                                                ]),
                                                "cell-ttd": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.day), 1)
                                                ]),
                                                "cell-tranche": _withCtx(({ row }) => [
                                                  (row?.tranche_data?.length > 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(row?.tranche_data?.label), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                "cell-total_target_trainee": _withCtx(({
                                            row,
                                          }) => [
                                                  _createTextVNode(_toDisplayString(row?.total_target_trainee), 1)
                                                ]),
                                                "cell-unit_cost": _withCtx(({ row }) => [
                                                  _createTextVNode(_toDisplayString(row?.unit_cost_total), 1)
                                                ]),
                                                "cell-actions": _withCtx(({ row }) => [
                                                  _createElementVNode("div", _hoisted_35, [
                                                    _createVNode(_component_router_link, {
                                                      class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                                      to: {
                                                name: 'courseProfileDetails',
                                                params: { id: row.id },
                                              }
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_36
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["to"]),
                                                    (_ctx.actionEdit)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          title: "Edit",
                                                          type: "button",
                                                          "data-kt-drawer-toggle": "true",
                                                          "data-kt-drawer-target": "#kt_drawer_course_info",
                                                          onClick: ($event: any) => (_ctx.editCourse(row)),
                                                          id: "kt_drawer_course_info_button",
                                                          class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                                        }, _hoisted_39, 8, _hoisted_37))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.actionEdit)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 1,
                                                          title: "Copy",
                                                          type: "button",
                                                          "data-kt-drawer-toggle": "true",
                                                          "data-kt-drawer-target": "#kt_drawer_course_copy_drawer",
                                                          onClick: ($event: any) => (_ctx.copyCourse(row)),
                                                          id: "kt_drawer_course_copy_drawer_button",
                                                          class: "btn btn-icon btn-bg-warning btn-active-color-warning btn-sm me-1"
                                                        }, _hoisted_42, 8, _hoisted_40))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.actionDelete)
                                                      ? (_openBlock(), _createBlock(_component_templete, { key: 2 }, {
                                                          default: _withCtx(() => [
                                                            (row?.batch_info?.length)
                                                              ? (_openBlock(), _createElementBlock("button", {
                                                                  key: 0,
                                                                  title: "Delete",
                                                                  type: "button",
                                                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.batchrunning())),
                                                                  class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                                                }, _hoisted_44))
                                                              : (_openBlock(), _createElementBlock("button", {
                                                                  key: 1,
                                                                  title: "Delete",
                                                                  type: "button",
                                                                  onClick: ($event: any) => (_ctx.Delete(row.id)),
                                                                  class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                                                }, _hoisted_47, 8, _hoisted_45))
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["table-data", "table-header"])
                                            ])
                                          ])
                                        ])
                                      ]))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.load]
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_CourseInfoDrawer),
    _createVNode(_component_CourseCopyDrawer)
  ], 64))
}